import React from "react"
import { Trans } from 'react-i18next'
import { ReactComponent as InfoIcon } from "../../icon/info.svg"
import { PropsWithTheme } from "../../library/Theme"

function Disclaimer({ theme }: PropsWithTheme<any>) {
  return (
    <div className="disclaimerContainer" style={theme.disclaimerStyle} >
      <div className="disclaimerIcon" style={theme.svgStyleAlternate}><InfoIcon /></div>
      <div>
        <p style={theme.textStyle}>
          <Trans i18nKey="splash.disclaimer">
            <span>Your photo will be uploaded to Simple Booth. Only continue if you agree to the</span>
            <a style={theme.textStyle} href="https://www.simplebooth.com/terms-of-service" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            <span> and </span>
            <a style={theme.textStyle} href="https://www.simplebooth.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
          </Trans>
        </p>
        {theme.customLegal && theme.customLegal}
      </div>
    </div>
  )
}

export default Disclaimer